import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { map } from 'rxjs/operators';

import { environment } from 'src/environments/environment';
import { SortableTable, convertDateToDisplayFormat, convertDateToBackendFormat } from './services-table-helper';

@Injectable({
  providedIn: 'root'
})

export class RapoarteFacturiNeachitateTableService extends SortableTable<any> {
  private baseUrl = environment.API_URL;

  rapoarteFacturiNeachitate: any[];
  numarRapoarteFacturiNeachitate: number;

  constructor(private http: HttpClient) {
    super();
  }

  sortEvent() {
    const tables = this.sort(this.rapoarteFacturiNeachitate, this._state.sortColumn, this._state.sortDirection);
    this._tables$.next(tables);
  }

  getRapoarteFacturiNeachitateAPI(obj) {
    return this.http.post(
      `${this.baseUrl}/contabilitate/rapoarte/facturineachitate/`,
      {
        ...obj,
        data_start: convertDateToBackendFormat(obj.data_start),
        data_end: convertDateToBackendFormat(obj.data_end)
      }
    ).pipe(map((response: any) => {
      this.rapoarteFacturiNeachitate = response.result;
      this.numarRapoarteFacturiNeachitate = response.count;

      this.rapoarteFacturiNeachitate.map((raport: any) => {
        raport.data = convertDateToDisplayFormat(raport.data);
      });

      this.paginate();
      this.sortEvent();
      this._total$.next(this.numarRapoarteFacturiNeachitate);

      return response;
    }));
  }

  exportXLS(obj) {
    return this.http
    .post(
      `${this.baseUrl}/contabilitate/rapoarte/facturineachitatexlsx/`,
      {
        ...obj,
        data_start: convertDateToBackendFormat(obj.data_start),
        data_end: convertDateToBackendFormat(obj.data_end)
      },
      {
        responseType: 'blob'
      }
    ).pipe(map((response: any) => {
      return response;
    }));
  }

  /**
   * Paginate Method
   */
  private paginate(): void {
    this.totalRecords = this.numarRapoarteFacturiNeachitate;
    this._state.startIndex = (this._state.page - 1) * this.pageSize + 1;
    this._state.endIndex = Number(this.pageSize) + Number(this._state.startIndex - 1);

    if (this._state.endIndex > this.numarRapoarteFacturiNeachitate) {
      this._state.endIndex = this.numarRapoarteFacturiNeachitate;
    }
  }
}
